module.exports = __webpack_public_path__ + "img/osmanthus_4.8bf6a5a5.png";